import { createIsomorphicFn } from '@tanstack/react-start';
import { getRequestHeader } from '@tanstack/react-start/server';
import { signClientIp } from '@_/shared/ip-signature.ts';

export const getSignedIpHeaders = createIsomorphicFn()
  .client(async (): Promise<Record<string, string>> => ({}))
  .server(async (): Promise<Record<string, string>> => {
    const ip = getRequestHeader('cf-connecting-ip');
    if (!ip) {
      return {};
    }

    const secret = process.env.CLIENT_IP_SECRET;
    if (!secret) {
      throw new Error('CLIENT_IP_SECRET is not set');
    }

    return {
      'x-signed-client-ip': await signClientIp(ip, secret)
    };
  });
